function Table({ children, className = '' }) {
  return (
    <div className={`table-container ${className}`}>
      <table>
        {children}
      </table>
    </div>
  )
}

function TableHead({ children }) {
  return <thead>{children}</thead>
}

function TableBody({ children }) {
  return <tbody>{children}</tbody>
}

function TableRow({ children, onClick, className = '' }) {
  return (
    <tr
      className={className}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      {children}
    </tr>
  )
}

function TableHeader({ children, className = '' }) {
  return <th className={className}>{children}</th>
}

function TableCell({ children, className = '' }) {
  return <td className={className}>{children}</td>
}

Table.Head = TableHead
Table.Body = TableBody
Table.Row = TableRow
Table.Header = TableHeader
Table.Cell = TableCell

export default Table
